/**
 * 商品购买相关工具：代购平台链接拼接、商品点击上报、打开购买链接
 */
import { Message } from 'element-ui'
import i18n from '@/i18n'
import productApi from '@/api/product'

/** 商品点击统计类型（与后端约定） */
const CLICK_TYPE = {
  GOODS: 'goods',
  SUIT: 'suit'
}

/**
 * 拼接代购平台购买链接（替换 {goodId} / {weidian} / {inviteCode} 占位符）
 * @param {Object} platform - 当前选择的代购平台，包含 platformUrl、invitationCode
 * @param {Object} goods - 商品数据，包含 weidianGoodsId、weidianId
 * @returns {string} 购买链接；platform 或 platformUrl 为空时返回空字符串
 */
export function buildPlatformBuyUrl(platform, goods) {
  if (!platform || !platform.platformUrl) return ''

  let url = platform.platformUrl
  if (url.indexOf('{goodId}') !== -1) {
    url = url.replaceAll('{goodId}', goods.weidianGoodsId)
  }
  if (url.indexOf('{weidian}') !== -1) {
    url = url.replaceAll('{weidian}', goods.weidianId)
  }
  if (url.indexOf('{inviteCode}') !== -1) {
    url = url.replaceAll('{inviteCode}', platform.invitationCode)
  }
  return url
}

/**
 * 上报商品点击统计
 * @param {Object} goods - 商品数据，包含 id（业务ID）、weidianGoodsId、weidianId
 * @param {string} clickType - 点击类型，goods=商品，suit=商品套装
 * @returns {void}
 */
export function reportGoodsClick(goods, clickType = CLICK_TYPE.GOODS) {
  const source = goods || {}
  productApi
    .addGoodsClick({
      // 业务ID：商品ID或商品套装ID
      businessId: source.businessId !== undefined ? source.businessId : source.id,
      // 点击类型：goods=商品，suit=商品套装
      clickType,
      // 微店商品ID（仅 goods 类型保存）
      weidianGoodsId: source.weidianGoodsId,
      // 微店ID（仅 goods 类型保存）
      weidianId: source.weidianId
    })
    .catch((error) => {
      console.error('统计商品点击失败:', error)
    })
}

/**
 * 打开代购平台购买链接：校验平台 → 拼接链接 → 新窗口打开
 * @param {Object} platform - 当前选择的代购平台，包含 platformId、platformUrl、invitationCode
 * @param {Object} goods - 商品数据，包含 weidianGoodsId、weidianId
 * @returns {void}
 */
export function openPlatformBuy(platform, goods) {
  if (!platform || !platform.platformId) {
    return Message.warning(i18n.t('selectPlatform'))
  }
  window.open(buildPlatformBuyUrl(platform, goods))
}
